import axios from 'axios';
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { configuration } from '../appConfig';


function findWithAttr(array, attr, value) {
  for(var i = 0; i < array.length; i += 1) {
      if(array[i][attr] === value) {
          return i;
      }
  }
  return -1;
}

class USCarDentTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data : {},
      lang: "us",
      words: {},
      clientName : "",
    }
  }

  componentDidMount() { 
    // this.getData();
    this.getLang();
  }

  getData = () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const url = `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`;
    axios.get(url)
    .then((r) => {
      if (r.data) {
        this.setState({ data: r.data, clientName : r.data.Client});
      }
    })
    .catch((err) => {
    }) 
  } 
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data!== this.props.data) {
      this.setState({data :this.props.data, clientName : this.props.data.Client})
    }
  }

  getTotalDents = (r) => {
    let total;
    total = (r.A ? r.A : 0) + (r.B ? r.B : 0) +  (r.C ? r.C : 0) + (r.D ? r.D : 0) + (r.E ? r.E : 0)
    return total;
  }

  getLang = () => {
    const base_url = window.location.origin;
    axios.get(`${base_url}/lang.json`).then((res) => {
      let lang = localStorage.getItem("lang");
      this.setState({ lang: lang });
      this.setState({ words: res.data });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };
  
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  render() {
    const { data, clientName } = this.state;
    const partnerId = localStorage.getItem("partnerId");
    const client = localStorage.getItem("client");
    // var order = [
    //   "Hood",
    //   "Roof",
    //   "TrunkCover",
    //   "RightRoofFrame",
    //   "LeftRoofFrame",
    //   "LeftBackFender",
    //   "LeftBackDoor",
    //   "LeftFrontDoor",
    //   "LeftFrontFender",
    //   "RightFrontFender",
    //   "RightFrontDoor",
    //   "RightBackDoor",
    //   "RightBackFender",
    //   // "Trunk",
    // ];
    var order = [
      "Hood",
      "LeftFrontFender",
      "RightFrontFender",
      "Roof",
      "LeftRoofFrame",
      "RightRoofFrame",
      "LeftFrontDoor",
      "RightFrontDoor",
      "LeftBackDoor",
      "RightBackDoor",
      "LeftBackFender",
      "RightBackFender",
      "TrunkCover",
      // "Trunk",
    ];
    const isCoopClient = clientName && clientName.toLocaleLowerCase() == "coop" ? true : false;
    data && data.Dents && data.Dents.length && data.Dents.sort(function(a, b) {
      // sort based on the index in order Dents
      return order.indexOf(a.Part) - order.indexOf(b.Part);
    });

    const isCanadaClient = ('CANADA' === client);
    return (
      <>
      <div className="row p-0 text-muted hide-report">
         <div className="table-responsive">
           <table className="table table-bordered table-striped dent-table-2d text-center">
             <thead>
               <tr>
                 <th>Part</th>
                 <th>DIME</th>
                 <th>{(isCanadaClient && isCoopClient) ? "QTR" : "NKL"}</th>
                 <th>{(isCanadaClient && isCoopClient) ? "TOONIE" : "QTR"}</th>
                 <th>{isCanadaClient ? 'OS' : 'HALF'}</th>
                 {!isCanadaClient &&  <th>OS</th>}
                 <th>Total</th>
               </tr>
             </thead>
             <tbody>
               {data.Dents &&
                 data.Dents.length &&
                 data.Dents.map((r, i) => {
                      if(['Trunk','Inside','Underbody','FrontBumper',"BackBumper","LeftFrontTyre","LeftBackTyre","RightFrontTyre","RightBackTyre"].includes(r.Part)) {
                        return;
                      }
                       
                      if(r.Part === 'TrunkCover') {
                        return (
                        <tr key={i}>
                         <td style={{ textAlign: "left" }}>{this.lang(r.Part)}</td>
                          <td>{ (r.A ? r.A : 0) + (data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].A ? data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].A : 0) }</td>
                          {
                            (isCanadaClient && isCoopClient) ? (<td>{ (r.C ? r.C : 0) + (data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].C ? data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].C : 0) }</td>
                          ) : (<td>{ (r.B ? r.B : 0) + (data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].B ? data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].B : 0) }</td>
                        )
                          }
                          {
                            (isCanadaClient && isCoopClient) ? (<td>{ (r.B ? r.B : 0) + (data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].B ? data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].B : 0) }</td>) : 
                            (<td>{ (r.C ? r.C : 0) + (data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].C ? data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].C : 0) }</td>)
                          }
                          <td>{ (r.D ? r.D : 0) + (data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].D ? data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].D : 0) }</td>
                          { !isCanadaClient && 
                            <td> {(r.E ? r.E : 0) + (data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].E ? data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].E : 0)}</td>
                          }

                          <td>{this.getTotalDents(r) + this.getTotalDents(data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')])}</td>
                       </tr>)
                      } else {
                       return <tr key={i}>
                         <td style={{ textAlign: "left" }}>{this.lang(r.Part)}</td>
                          <td>{r.A}</td>
                          {(isCanadaClient && isCoopClient) ? ( <td>{r.C}</td>) : (<td>{r.B}</td>)}
                          {(isCanadaClient && isCoopClient) ? (<td>{r.B}</td>) : (<td>{r.C}</td>)}
                          <td>{r.D}</td>
                          {!isCanadaClient && <td>{r.E}</td>}
                          <td>{this.getTotalDents(r)}</td>
                       </tr>
                      }
                 })}
             </tbody>
           </table>
         </div>
       </div>
      </>
    )
  }
}
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(USCarDentTable);